/* src/app/umbrella-common/cookies-banner/cookies-banner.component.scss */
#cookie-banner {
  font-family: Arial, sans-serif;
  font-size: 15px;
  background-color: #007d40;
  box-sizing: border-box;
  overflow: hidden;
  padding: 0 25px;
  width: 100%;
  z-index: 100005;
}
#cookie-banner.sticky {
  position: -webkit-sticky;
  position: sticky;
  display: block;
  top: 0;
}
#cookie-banner .cookie-banner-wrapper {
  max-width: 1120px;
  margin: 25px auto;
  min-height: 35px;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
}
#cookie-banner .cookie-banner-wrapper .cookie-banner-text {
  box-sizing: border-box;
  padding-right: 30px;
  width: 80%;
}
#cookie-banner .cookie-banner-wrapper .cookie-banner-text .title {
  font-weight: bold;
}
#cookie-banner .cookie-banner-wrapper .cookie-banner-text p {
  color: #fff;
  font-size: 0.875rem;
  line-height: 1.6;
  margin: 0;
}
#cookie-banner .cookie-banner-wrapper .cookie-banner-buttons {
  overflow: hidden;
  width: 20%;
  color: #585858;
}
#cookie-banner .cookie-banner-wrapper .cookie-banner-buttons .banner-btn {
  width: 100%;
  background-color: #fff;
  color: #007d40;
  border: none;
  box-sizing: border-box;
  cursor: pointer;
  float: right;
  font-size: 13px;
  margin: 0;
  text-align: left;
  text-transform: uppercase;
  padding: 10px 40px 9px 15px;
  position: relative;
  line-height: 16px;
  display: inline-block;
  transition: all 0.1s;
  overflow: visible;
  font-family: sans-serif;
}
#cookie-banner .cookie-banner-wrapper .cookie-banner-buttons .settings-btn {
  margin-top: 15px;
}
#cookie-banner .cookie-banner-wrapper .cookie-banner-buttons .banner-btn:hover {
  text-decoration: underline;
}
#cookie-banner .cookie-banner-wrapper .cookie-banner-buttons #arrow-icon {
  max-width: 24px;
  max-height: 24px;
  font-size: 15px;
  position: absolute;
  transform: translate(0, -50%);
  top: 50%;
  right: 10px;
}
#cookie-banner .close-btn {
  background-color: #007d40;
  border: none;
  position: absolute;
  top: 10px;
  right: 10px;
}
#cookie-banner .close-btn nb-icon {
  color: #fff;
  max-width: 24px;
  max-height: 24px;
}
@media screen and (max-width: 1250px) {
  #cookie-banner .cookie-banner-wrapper {
    display: flex;
    flex-direction: column;
  }
  #cookie-banner .cookie-banner-wrapper .cookie-banner-text {
    width: 100%;
  }
  #cookie-banner .cookie-banner-wrapper .cookie-banner-buttons {
    margin: 10px 0 0 0;
    width: 205px;
    min-width: 205px;
  }
}
/*# sourceMappingURL=cookies-banner.component.css.map */
